<template>

     <!-- :cell-style="cellStyle" :row-style="rowStyle" -->
  <basic-container class="orderSetting20210825" id = "ordersettingsubmodule20211204">
    <avue-crud
    :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="onLoad"
               @on-load="onLoad">


      <template slot-scope="{ row }" slot="groupId">

          <span>
          {{getGroupName(row.groupId)}}
        </span>


      </template>
      <template slot-scope="{ row }" slot="status">
        <el-tag
          style="font-size: 14px; width: 76px; height: 32px; line-height: 32px; text-align: center;"
          :type="row.status === 0 ? 'danger' : 'success'"
        >
          {{ row.status === 0 ? '未启用' : '已启用' }}</el-tag
        >
      </template>
                   <!-- v-if="permissionList.useBtn" -->
      <template slot-scope="scope" slot="menu">
        <el-button type="text"
                   size="small"
                   icon="el-icon-edit-outline"
                   @click.native="changeStatus(scope.row)">&nbsp;{{getLabelName(scope.row.status)}}
        </el-button>
      </template>
          <template slot="groupIdForm">
            <el-select v-model="form.groupId" placeholder="请选择服务班组" :disabled="isViewForm">
              <el-option
                v-for="(item,index) in projectGroupList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </template>
    </avue-crud>
  </basic-container>
</template>

<script>
  import {
    getGroupList,
    // getProjectList,
    // changeOrderSettingStatus
  } from "@/api/v4ward/ordersetting/setting/ordersetting";
  import {mapGetters} from "vuex";
  import { getList,update,add } from "@/api/v4ward/ordersetting/setting/ordersubmodule";
export default {
  props:['projectId','settingId','moduleType'],
  data(){
    return{
      isViewForm:false,
      projectGroupList:[],
      page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
      form: {},
      option: {
          height: 'auto',
          // calcHeight: 30,
          tip: false,
          searchShow: true,
          // searchMenuSpan: 6,
          border: true,
          index: true,
          viewBtn: true,
          delBtn: false,
          selection: false,
          indexLabel: '序号',
          align: 'left',
          dialogClickModal: false,
          // dialogWidth: 800,
          columnBtn: true,
          // menuWidth:280,
          column: [
            // {
            //   label: "子类ID",
            //   prop: "id",
            //   type: "input",
            //   hide: true,
            //   editDisplay: false,
            //   addDisplay: false,
            //   viewDisplay: false,
            //   // search: true,
            //   // searchslot: true,
            // },
            // {
            //   label: "工单设置ID",
            //   prop: "settingId",
            //   type: 'input',
            //   // dicUrl: 'api/v4ward/project/getProjectList',
            //   editDisabled: true,
            //   editDisplay: false,
            //   addDisplay: false,
            //   hide:true,
            //   // props: {
            //   //   label: 'name',
            //   //   value: 'id',
            //   // },
            //   rules: [{
            //     required: true,
            //     message: "请选择项目名称",
            //     trigger: "change"
            //   }]
            // },
            {
              label: "子类型名",
              prop: "name",
              type: "input",
              maxlength: '50',
              editDisabled: false,
              order:6,
              // width: 120,
              // search: true,
              // dicUrl: '/api/blade-system/dict/dictionary?code=module_type',
              // props: {
              //   label: 'dictValue',
              //   value: 'dictKey',
              // },
              // dataType: 'number',
              rules: [{
                required: true,
                message: "请输入子类姓名",
                trigger: "blur"
              }]
            },
            // {
            //   label: "服务班组",
            //   prop: "groupId2",
            //   type: "input",
            //   // editDisplay: false,
            //   // dicUrl: '/api/blade-system/dict/dictionary?code=module_type',
            //   dicData: [],
            //   hide: true,
            //   formslot:true,
            //   props: {
            //     label: 'name',
            //     value: 'id',
            //   },
            //   rules: [{
            //     required: true,
            //     message: "请选择服务班组",
            //     trigger: "change"
            //   }]
            // },

            {
              label: "状态",
              prop: "status",
              type: "input",
              editDisplay: false,
              addDisplay: false,
              viewDisplay: false,
              // width: 120,
              slot:true,
              order:5,
              // search: true,
              // dicUrl: '/api/blade-system/dict/dictionary?code=module_type',
              // props: {
              //   label: 'dictValue',
              //   value: 'dictKey',
              // },
              // dataType: 'number',
              rules: [{
                required: true,
                message: "请输入状态",
                trigger: "blur"
              }]
            },
            {
              label: "服务班组",
              prop: "groupId",
              type: "select",
              // editDisplay: false,
              // dicUrl: '/api/blade-system/dict/dictionary?code=module_type',
              placeholder:'请选择服务班组',
              dicData: [],
              // viewDisplay: false,
              // hide: true,
              slot:true,
              formslot:true,
              props: {
                label: 'dic',
                value: 'id',
              },
              order:4,
              rules: [{
                required: true,
                message: "请选择服务班组",
                trigger: "change"
              }]
            },
            {
              label: "排序",
              prop: "sort",
              maxlength: 4,
              showWordLimit: true,
              order:3,
              rules: [
                { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入自然数' },
                {
                  required: true,
                  message: "请输入排序",
                  trigger: "change"
                }]
            },
            {
              label: "备注",
              prop: "remark",
              type: "textarea",
              maxlength: 200,
              span: 24,
              // editDisabled: true,
              // width: 120,
              // search: true,
              // dicUrl: '/api/blade-system/dict/dictionary?code=module_type',
              // props: {
              //   label: 'dictValue',
              //   value: 'dictKey',
              // },
              // dataType: 'number',
              order:1,
              rules: [{
                required: true,
                message: "请输入备注",
                trigger: "blur"
              }]
            },
            {
              label: '允许下单',
              prop: "createOrderFlag",
              type: 'switch',
              order:2,
              dicData: [{
                label: '否',
                value: 0
              }, {
                label: '是',
                value: 1
              }],
              rules: [{
                required: true,
                trigger: "blur"
              }]
            }
          ]
        },
        data: [],

    }
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        // addBtn: this.vaildData(this.permission.ordersetting_add, true),
        // viewBtn: this.vaildData(this.permission.ordersetting_view, false),
        // delBtn: this.vaildData(this.permission.ordersetting_delete, false),
        // editBtn: this.vaildData(this.permission.ordersetting_edit, true),
        // flowBtn: this.vaildData(this.permission.ordersetting_flow, true),
        // componentsBtn: this.vaildData(this.permission.ordersetting_components, true),
        // useBtn: this.vaildData(this.permission.ordersetting_use, true),
      };
    },
  },
  created(){
    getGroupList({projectId:this.projectId, moduleType:this.moduleType}).then((res)=>{
      console.log(res);
      this.projectGroupList = res.data
    });
  },
  mounted(){
    this.setAvueCrudHeight()
  },
  methods:{
    setUiStandard(){
        let dom = this.$refs.crud.$children[4].$children[0].$refs.dialog
      dom.className+=" lhrodersetting01"
      dom.id = 'lhrodersetting01'
      console.log("***ee",this.$refs.crud.$children[4].$children[0].customClass)
        console.log("***dd",this.$refs.crud.$children[4].$children[0])
    },
    setAvueCrudHeight(){
      this.option.height = this.bodyHeight  - 379;
      
    },
    // rowStyle({row,column,rowIndex}){
    //     if(rowIndex%2===0){
    //       return {
    //           backgroundColor:'#eee',
    //           color:'#fff'
    //       }
    //     }
    //   },
getGroupName(id){
  let name = '';
  this.projectGroupList.forEach((ele,index)=>{
    if(id===ele.id){
      name = ele.name;
    }
  })
  return name;
},

      beforeOpen(done, type) {
        this.setUiStandard()
        console.log(type);
        if (["view"].includes(type)) {
          this.isViewForm = true;
        }else{
          this.isViewForm = false;
        }
        if(["add"].includes(type)){
          setTimeout(()=>{
            this.form.createOrderFlag = 1;
          },0)
        }
        done();
      },
      getLabelName(status) {
        if (status === 1) {
          return '停用';
        } else {
          return '启用';
        }
      },
      changeStatus(row) {
        let status =  row.status === 1 ? 0 : 1;
        let label = '确认停用此工单?';
        if(status === 1){
          // label = '附件组件是否已经配置?';
          label = '确认启用此工单?';
        }
        this.$confirm(label, {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning"
        }).then(() => {
          // let param = {id: row.id, status: status, projectId: row.projectId,moduleType: row.moduleType};
          row.settingId = this.settingId;
          row.status = status;
          // eslint-disable-next-line no-unused-vars
          update(row).then(res => {
            // row.status = param.status;
            this.$message.success('操作成功!');
            this.onLoad();
          })
        });
      },
      rowSave(row, done, loading){

        console.log(row);
        row.settingId = this.settingId;
        // return;
        add(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowUpdate(row, index, done, loading) {
        update(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      searchReset() {
        this.query = {};
        this.onLoad();
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        // if (this.vdui.isNotEmpty(this.queryProjectId)) {
          // this.query.projectId = this.queryProjectId;
          // this.form.projectId = this.queryProjectId;
          page = page || this.page;
          getList(
            Object.assign({current: page.currentPage, size: page.pageSize, settingId:this.settingId}, this.query)
          ).then(({data}) => {
            this.page.total = data.total;
            this.data = data.records;
            this.form.createOrderFlag = 1;
            this.selectionClear();
          });
        // }
      }
  }
}
</script>

<style lang="scss" scoped>
.orderSetting20210825{
  .el-table .cell {
      white-space: inherit;
  }
}
#ordersettingsubmodule20211204{
  .avue-crud .el-icon-view{
    display: none;
  }
  .avue-crud .el-icon-edit{
    display: none;
  }
}
::v-deep .el-table--small{
  height: 690px!important;
}
::v-deep .avue-crud__pagination{
  padding-bottom:0!important;
}
::v-deep .el-table .cell{
  line-height: 60px!important;
}
</style>
